import React              from 'react';
import ChatBot            from 'react-simple-chatbot';
import { ThemeProvider }  from 'styled-components';
import { connect }        from 'react-redux';
import { withRouter }     from 'react-router';
import PubSub             from 'pubsub-js';
import { AwsConstants }   from '../../../utils/environment';
import { chatUserId }     from '../../../utils/authService';
import { chatFetchData }  from '../../../actions/chat/chat';
import { lexCBFetchData } from '../../../actions/chat/lexCB';
import logo               from '../../../images/bsu-dns.png';
import LookUp             from './LookUp.js';
import ProblemLookUp      from './ProblemLookUp.js';

// /aws/lambda/catalog-core-local-chat
 
var apiHost = AwsConstants.WebApiHost;

var HELP_MSG   = 'Hi! You can connect to services such as account management. Select list to see available categories or select problem to report a problem.';

const theme = {
  background: '#f5f8fb',
  // Let the theme take this over - fontFamily: 'Helvetica Neue',
  headerBgColor: '#0033a0',
  headerFontColor: '#fff',
  // headerFontSize: '15px',
  botBubbleColor: '#0033a0',
  botFontColor: '#fff',
  userBubbleColor: '#fff',
  //userFontColor: '#4a4a4a',
};
/**
 * Home of the Chatbot. Has the steps that Chatbot supports and calls custom 
 * components that allow look ups to Dell Boomi and AWS Lex. 
 */
class Chat extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      value: ''
    };

  }
  
  componentWillUnmount(){
    PubSub.unsubscribe(this.token);
  }
  
  handleNewUserMessage = (newMessage) => {
    var msg = {
      text: newMessage,
      userId: chatUserId(),
      page: this.props.location.pathname      
    };
    
    this.props.fetchData(apiHost, msg);
  }

  handleNewLexMessage = (newMessage) => {
    var msg = {
      text: newMessage,
      userId: chatUserId(),
      page: this.props.location.pathname      
    };
    
    this.props.fetchLex(apiHost, msg);
  }
 
  render() {
    return (
    <ThemeProvider theme={theme}>
      <ChatBot 
        botAvatar={logo} //Set logo for chatbot
        floating='true' //Set up floating button in bottom right
        headerTitle='Services Catalog Chatbot'
        /* All the steps that chatbot can reach */
        steps={[
          {
            id: 'hello-world',
            message: HELP_MSG,
            trigger: 'select-options'
          },
          {
            id: 'select-options',
            options: [
              { value: 1, label: 'List', trigger: 'list' },
              { value: 3, label: 'Look up!', trigger: 'look-up-start'},
              { value: 2, label: 'Problem', trigger: 'problem'},
            ],
          },
          {
            id: 'select-options-full',
            options: [
              { value: 1, label: 'List', trigger: 'list' },
              { value: 3, label: 'Look up!', trigger: 'look-up-start'},
              { value: 2, label: 'Problem', trigger: 'problem'},
              { value: 4, label: 'Web Hosting', trigger: 'web-hosting'},
              { value: 5, label: 'Account Access', trigger: 'account-access'},
              { value: 6, label: 'Fun', trigger: 'fun'},
            ],
          },
          {
            id: 'list',
            message: 'Here\'s our list of available services',
            trigger: 'select-options-full',
          },
          {
            id: 'problem', //BOOMI 
            message: 'What is the problem you would like to report?',
            trigger: 'problemUser',
          },
          {
            id: 'problemUser', //Get user's problem
            user: true,
            trigger: 'problem-email',
          },
          {
            id: 'problem-email', //Ask for email
            message: 'Would you like to put an email for contact purposes?',
            trigger: 'email-check',
          },
          {
            id: 'email-check',
            options: [
              { value: 1, label: 'Yes', trigger: 'userEmail'},
              { value: 2, label: 'No', trigger: 'problem-look-up'},    
            ],
          },
          {
            id: 'userEmail', //Get email
            user: true,
            trigger: 'problem-look-up', 
          },
          {
            id: 'problem-look-up', //Send request to Boomi and ServiceNow
            component: <ProblemLookUp fetch={this.handleNewUserMessage} />,
            asMessage: true,
            waitAction: true, //The component must activate the next step in order to advance
            trigger: 'problem-finish',
          },
          {
            id: 'problem-finish',
            message: 'Thank you for your assistance! Let me know if you need anything else!',
            trigger: 'select-options',
          },
          {
            id: 'web-hosting',
            message: 'Eventually, you\'ll get redirected to web hosting!',
            trigger: 'select-options',
          },
          {
            id: 'account-access',
            component: (
              <div>Eventually, you'll get redirected to account access!</div>
            ),
            asMessage: true,
            trigger: 'select-options',
          },
          {
            id: 'fun',
            message: 'Yo-ho-ho! Ahoy! I am a pirate chat bot now!',
            trigger: 'select-options',
          },
          {
            id: 'look-up-start', //LEX
            message: 'Type something to look up!',
            trigger: 'search',
          },
          {
            id: 'search', //Get value from user to look up
            user: true,
            trigger: 'look-up',
          },
          {
            id: 'look-up', //Look up value and print out response from Lex
            component: <LookUp fetch={this.handleNewLexMessage} />,
            asMessage: true,
            waitAction: true, //The component must activate the next step in order to advance
            trigger: 'select-options',
          },
        ]}
      />
    </ThemeProvider>
  );
  }
}

const mapStateToProps = state => {
  return {
    chat: state.chat.chat.chat,
    hasErrored: state.chat.chat.chatHasErrored,
    isLoading: state.chat.chat.chatIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (host, msg) => dispatch(chatFetchData(host, msg)),
    fetchLex: (host, msg) => dispatch(lexCBFetchData(host, msg))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Chat));
